// Local editing keys cannot collide with a valid SKU. Requests identify a listing by its original row.
const prefix='\u0000listing:';
export const orderProductKey=(row:{sku:string;listing_row?:number})=>row.listing_row?prefix+row.listing_row:row.sku;
export const listingRow=(key:string)=>key.startsWith(prefix)?Number(key.slice(prefix.length)):undefined;
export const orderProductInput=({sku,quantity}:{sku:string;quantity:number|null})=>{
    const number=listingRow(sku);
    return number===undefined?{sku,quantity}:{listing_row:number,quantity};
};
